import { render, staticRenderFns } from "./ValidationForms.vue?vue&type=template&id=36e0b362"
import script from "./ValidationForms.vue?vue&type=script&lang=js"
export * from "./ValidationForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports